/**
 * @generated SignedSource<<61ee7d5f738cc98034d43a421c89ccd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AnsweringTypeV2 = "allowMultipleAnswersAllCorrectMustBeGiven" | "allowMultipleAnswersOnlySomeCorrectMustBeGiven" | "allowOnlyOneAnswer" | "%future added value";
export type multipleChoiceAnswersDropdowns_Query$variables = {
  elementId: string;
};
export type multipleChoiceAnswersDropdowns_Query$data = {
  readonly LearnV2: {
    readonly GetLearnElement: {
      readonly answerOptions: ReadonlyArray<{
        readonly answer: string;
      }>;
      readonly answeringType: AnsweringTypeV2;
      readonly id: string;
    };
  };
};
export type multipleChoiceAnswersDropdowns_Query = {
  response: multipleChoiceAnswersDropdowns_Query$data;
  variables: multipleChoiceAnswersDropdowns_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "elementId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Queries",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "elementId",
            "variableName": "elementId"
          }
        ],
        "concreteType": "MultipleChoiceLearnElement",
        "kind": "LinkedField",
        "name": "GetLearnElement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AnswerOptionWithoutCorrect",
            "kind": "LinkedField",
            "name": "answerOptions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answer",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answeringType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "multipleChoiceAnswersDropdowns_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "multipleChoiceAnswersDropdowns_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "99268daca09bdbb3274fcd018cd07b10",
    "id": null,
    "metadata": {},
    "name": "multipleChoiceAnswersDropdowns_Query",
    "operationKind": "query",
    "text": "query multipleChoiceAnswersDropdowns_Query(\n  $elementId: ID!\n) {\n  LearnV2 {\n    GetLearnElement(elementId: $elementId) {\n      id\n      answerOptions {\n        answer\n      }\n      answeringType\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "61163f1a5844540cd398001ecce09601";

export default node;
